// CompanyEditNewCompanyMessageTypeList - MODULE
// ***********************************************************************************************************************
import { Box, Typography } from "@mui/material";
import * as React from "react";
import { AvatarImage } from "ui/Scripts/source/components/framework/Avatar/AvatarImage";
import { Translations } from "ui/Scripts/source/models/translations";
import { IMessageTypeListItem } from "../../../../models/messageType/messageTypeListItem";
import { List } from "../../../framework/List/List";

// CompanyEditNewCompanyMessageTypeList
export interface ICompanyEditNewCompanyMessageTypeListProp {
    items: IMessageTypeListItem[];
    checkedIds: string[];
    onSetCheckedIds: (ids: string[]) => void;
}

export class CompanyEditNewCompanyMessageTypeList extends React.Component<ICompanyEditNewCompanyMessageTypeListProp, {}> {
    handleSetSelectedIds = (selectedId: string, checkedIds: string[]) => {
        this.props.onSetCheckedIds(checkedIds);
    };

    render() {
        const props = this.props;
        return (
            <Box sx={{ margin: "-1rem" }}>
                <List
                    intialized={true}
                    isLoading={false}
                    hasMore={false}
                    globalLoadingInUse={true}
                    header={{
                        columns: [
                            { size: 6, column: "code", content: Translations.Code },
                            { size: 6, column: "name", content: Translations.Name }
                        ]
                    }}
                    lines={props.items.map((item) => {
                        return {
                            columns: [
                                {
                                    size: 6,
                                    column: "code",
                                    content:
                                        <Box display="flex" alignItems="center">
                                            <AvatarImage
                                                name={item.name}
                                                image={item.image}
                                                tooltip={item.name}
                                                marginRight=".5rem"
                                            />
                                            <Typography>{item.code}</Typography>
                                        </Box>
                                },
                                { size: 6, column: "name", content: item.name },
                            ],
                            id: item.id
                        };
                    })}
                    sortColumn={""}
                    sortOrderIsAsc={true}
                    selectedId={""}
                    checkedIds={props.checkedIds}
                    multiSelect={true}
                    onSetSelectedIds={this.handleSetSelectedIds}
                    onSearchLines={(sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {}}
                />
            </Box>
        );
    }
}